$(document).ready(function (){
  
  var floatingImageElement = $('.product-detail-block__item.item-type--image');
  $('.item__product-image').click(function() {
    var image = $(this).find('img');
	floatingImageElement.find('img').attr('src', image.attr('data-src-big'));
    
    $('.item__product-image').removeClass('active');
    $(this).addClass('active');
  });
  
  var canScrollableParentElement = $('.product-detail-block__item.item-type--image');
  var canScrollableElement = $('.product-detail-block__item.item-type--image img');
  var canScrollablePosition = canScrollableParentElement.position();
  var productDetailHeight = $('.product-detail-block-wrapper').height();
  var productNutritionalFactElement = $('.product-detail-nutritional-facts-block');
  
  if ($(window).width() > 990) {
    ScrollTrigger.create({
      trigger: canScrollableParentElement,
      start: "top 140px", 
      end: "+=" + (productDetailHeight - canScrollableElement.height() - 35),
      pin: canScrollableParentElement
    });
  }
  
  $('.drawer__close-button').click(function() {
    $('.product-detail__left-drawer-wrapper').animate({
      left: '-40vw',
    }, function() {

      $('.product-detail__left-drawer-wrapper').css({
        display: 'none'
      });

      $('body').removeClass('no-scroll');
    })
  });
  
  $('.free-next-day-delivery__trigger').click(function() {

    $('.product-detail__left-drawer-wrapper').css({
      display: 'block'
    });

    $('.product-detail__left-drawer-wrapper').animate({
      left: 0,
    })

    $('body').addClass('no-scroll');
    
  });
  
  $('.scroll-to-timeline').click(function() {
    
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".timeline-and-image-block-wrapper").offset().top - 98
    }, 1000);
    
  });
  
  // Timeline
//   var timelineItemActiveCounter = 1;
//   setInterval(function() {
    
//     $('.timeline-and-image__timeline-items-wrapper .timeline-item').removeClass('active');
//     $('.timeline-and-image__timeline-items-wrapper .timeline-item:nth-child('+ timelineItemActiveCounter +')').addClass('active');
    
//     if (timelineItemActiveCounter == 3) {
//       timelineItemActiveCounter = 0;
//     }
    
//     timelineItemActiveCounter += 1;
//   }, 2000);
  
  // Nutritional facts
  var nutritionalFactsWrapper = document.querySelector('.product-detail-nutritional-facts-block-wrapper');
  var nutritionalFactsWrapperScrollHeight = $(nutritionalFactsWrapper).get(0).scrollHeight;
  
  var nutritionalFactsText = document.querySelector('.nutritional-facts-text');
  var nutritionalFactsTextScrollHeight = $(nutritionalFactsText).get(0).scrollHeight;
  
  if ($(window).width() > 990) {
      var nutritionalFactsImageHeight = $('.nutritional-facts-image .img').height();

      $('.nutritional-facts-wrapper').outerHeight(nutritionalFactsImageHeight);
      $('.nutritional-facts-text').outerHeight(nutritionalFactsImageHeight);
    
    $(window).on('resize', function() {
      nutritionalFactsImageHeight = $('.nutritional-facts-image .img').height();

      $('.nutritional-facts-wrapper').outerHeight(nutritionalFactsImageHeight);
      $('.nutritional-facts-text').outerHeight(nutritionalFactsImageHeight);
    })
    
    ScrollTrigger.create({
      trigger: '.product-detail-nutritional-facts-block-wrapper',
      start: "center center",
      end: "+=0",
      pin: true,
      pinType: 'transform',
      scrub: 1,
      onUpdate: self => {
        nutritionalFactsText.scrollBy({
          top: self.direction < 0 ? -30 : 30,
        });
      },
      onLeaveBack: ({progress, direction, isActive}) => {
        nutritionalFactsText.scrollBy({
          top: -1 * nutritionalFactsTextScrollHeight,
          behavior: 'smooth'
        });
      },
      onLeave: ({progress, direction, isActive}) => {
        nutritionalFactsText.scrollBy({
          top: nutritionalFactsTextScrollHeight,
          behavior: 'smooth'
        });
      },
    });
  }
  
});

$(window).on('load', function() {
  
  /* Recharge */
  setTimeout(function() {

    var widgetObject = window.Recharge.widgets[Object.keys(window.Recharge.widgets)[0]];
    var variantObject = widgetObject.product.variants[0];
    var variantPrice = variantObject.prices;
    var unitPrice = parseInt(variantPrice.unit_price);
    var discountedPrice = parseInt(variantPrice.discounted_price);
    
    var rcSellingPlanAdditionalPlan = $('#rc-selling-plan-additional-text').html();
    var rcOnetimePurchasePlanAdditionalPlan = $('#rc-onetime-purchase-plan-additional-text').html();
    
    var purchaseOptionEl = $('body input[name="purchaseOption"]');
    var quantityInputEl = $('body input.quantity__input');

    if ($('body input[name="purchaseOption"]:checked').val() == 'subscription') {
     // $('.product-detail-price__item').find('.price-item').text('$' + discountedPrice); 
    }

    purchaseOptionEl.change(function(){
      var price = '$' + unitPrice;
      if ($(this).val() == 'subscription') {
        price = '$' + discountedPrice;

        
        // Add custom text to plan| one-time
        $('.rc-selling-plans').prepend('<div class="rc-selling-plans__additional-text">'+ rcSellingPlanAdditionalPlan +'</div>');
        $('.rc-radio.onetime-radio').find('.rc-selling-plans__additional-text').hide();
      } else {
        
        // Add custom text to plan| one-time
        $('.rc-radio.onetime-radio').find('.rc-selling-plans__additional-text').show();
      }

      //$('.product-detail-price__item').find('.price-item').text(price);
    });
    
//     quantityInputEl.change(function(){
      
//       if ($(this).val() == 2 && $('body input[name="purchaseOption"]:checked').val() == 'subscription') {
//         $('button.quantity__button[name="minus"]').addClass('invisible');
//       } else {
//         $('button.quantity__button[name="minus"]').removeClass('invisible');
//       }
//     })

    // badge discount
    $('.rc-widget').append('<div class="product-detail__badge-discount">Save 10%</div>');
    
    // copy the stars
    $('#shopify-block-fc1df903-06a6-4c19-9e35-434631ff3ab6').clone().appendTo('.product-detail-block__item.item-type--text .product-detail__preview-star-wrapper');
    
    // change the one-time password text
    $('.rc-radio.onetime-radio .rc-radio__label').text('One-time purchase');
  
    // Change subscribe text
    var subscribeAndSaveText = widgetObject.widgetSettings.subscribe_message;
    $('.rc-radio__subscription').html(subscribeAndSaveText);
    
    // load basis Subscribe & save purchase 
    $("span.rc-radio__subscription").eq(0).text("Subscribe & save ($17/can)");
    // load basis one time purchase 
    $("span.rc-radio__label").eq(1).text("One-time purchase ($19/can)");
    
    // Add custom text to plan
    $('.rc-selling-plans').prepend('<div class="rc-selling-plans__additional-text">'+ rcSellingPlanAdditionalPlan +'</div>');
    $('.rc-radio.onetime-radio').click();
    $('.rc-radio.onetime-radio').append('<div class="rc-selling-plans__additional-text">'+ rcOnetimePurchasePlanAdditionalPlan +'</div>');
    
  }, 1000);
  
  // Change the product review background
  $('body #shopify-product-reviews').closest('section').addClass('shopify-product-reviews');
});